/*
  Founders List sign-up (snippets/rf-signup.liquid).
  Submits Shopify's native customer form with fetch so the visitor stays on
  the page, then reads the result the theme rendered for this form's id.
  If Shopify answers with a bot challenge, falls back to a normal submit so
  the visitor can complete it.
*/
(function () {
  var GENERIC_ERROR = 'Something went wrong. Please try again.';
  var EMAIL_ERROR = "That email doesn't look right. Check it and try again.";
  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setStatus(el, text, state) {
    el.textContent = text;
    el.classList.toggle('is-error', state === 'error');
    el.classList.toggle('is-success', state === 'success');
  }

  function setBusy(form, busy) {
    var button = form.querySelector('button[type="submit"]');
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (button) button.disabled = busy;
  }

  // Posts the form; resolves to {state: 'success'|'error'|'challenge', message}.
  function post(form) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      headers: { Accept: 'text/html' }
    }).then(function (response) {
      if (response.url.indexOf('/challenge') !== -1) return { state: 'challenge' };
      return response.text().then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rendered = doc.getElementById(form.id);
        var result = rendered && rendered.querySelector('[data-rf-result]');
        if (result) {
          return { state: result.getAttribute('data-rf-result'), message: result.textContent.trim() };
        }
        if (response.url.indexOf('customer_posted=true') !== -1) return { state: 'success' };
        // Not our page at all (e.g. Shopify's "Verifying your connection" check):
        // let the browser submit normally so the visitor can get through it.
        if (!rendered) return { state: 'challenge' };
        return { state: 'error' };
      });
    });
  }

  var nativeSubmit = HTMLFormElement.prototype.submit;

  // Full-page submit. requestSubmit fires the submit event, so Shopify's captcha
  // handler still runs and adds its token before the page posts.
  function submitNatively(form) {
    form.dataset.rfNative = 'true';
    if (form.requestSubmit) form.requestSubmit();
    else nativeSubmit.call(form);
  }

  // Validation before anything is sent. Returns false to stop the submit.
  function prepareEmailStep(form) {
    var input = form.querySelector('input[type="email"]');
    var status = form.querySelector('.rf-signup-status');
    if (!EMAIL_PATTERN.test(input.value.trim())) {
      input.setAttribute('aria-invalid', 'true');
      setStatus(status, EMAIL_ERROR, 'error');
      input.focus();
      return false;
    }
    input.removeAttribute('aria-invalid');
    setStatus(status, '', null);
    // Never send an empty note: it could blank a returning customer's saved note.
    var note = form.querySelector('[data-rf-note-main]');
    if (note) note.disabled = !note.value.trim();
    return true;
  }

  function prepareInterestStep(form) {
    var select = form.querySelector('[data-rf-watch]');
    var status = form.querySelector('.rf-signup-status');
    var tagsInput = form.querySelector('input[name="contact[tags]"]');
    if (!select.value) {
      setStatus(status, 'Pick a watch first, or skip this step.', 'error');
      select.focus();
      return false;
    }
    form.querySelector('[data-rf-note]').value = 'Most interested in: ' + select.options[select.selectedIndex].text;
    tagsInput.value = tagsInput.dataset.rfBaseTags + ',interest-' + select.value;
    setStatus(status, '', null);
    return true;
  }

  function showInterestStep(root, email) {
    var step = root.querySelector('[data-rf-step2]');
    if (!step) return;
    step.querySelector('[data-rf-email]').value = email;
    step.hidden = false;
  }

  // Sends the form in place and shows the result.
  function send(form) {
    var root = form.closest('[data-rf-signup]');
    var isInterest = form.classList.contains('rf-signup-interest');
    var status = form.querySelector('.rf-signup-status');
    var input = form.querySelector('input[type="email"]');
    setBusy(form, true);

    post(form)
      .then(function (result) {
        if (result.state === 'challenge') return submitNatively(form);
        if (result.state === 'success') {
          form.querySelector('.rf-signup-row').hidden = true;
          setStatus(status, isInterest ? 'Saved. Thanks.' : root.dataset.success, 'success');
          status.focus();
          if (!isInterest) showInterestStep(root, input.value.trim());
          return;
        }
        setStatus(status, (!isInterest && result.message) || GENERIC_ERROR, 'error');
        if (!isInterest) {
          input.setAttribute('aria-invalid', 'true');
          input.focus();
        }
      })
      .catch(function () {
        setStatus(status, GENERIC_ERROR, 'error');
      })
      .then(function () {
        setBusy(form, false);
      });
  }

  document.querySelectorAll('[data-rf-signup] form').forEach(function (form) {
    // Validate ourselves so the error appears on the page, not in a browser bubble.
    form.noValidate = true;
    // Shopify's hCaptcha check intercepts the submit, adds its token, then calls
    // form.submit(). Catch that call and send it in place instead of reloading.
    form.submit = function () {
      if (form.dataset.rfNative === 'true') return nativeSubmit.call(form);
      send(form);
    };
  });

  function signupForm(event) {
    var form = event.target;
    if (!form.closest || !form.closest('[data-rf-signup]') || form.dataset.rfNative === 'true') return null;
    return form;
  }

  // Capture phase: runs before Shopify's captcha handler, so bad input never reaches it.
  document.addEventListener('submit', function (event) {
    var form = signupForm(event);
    if (!form) return;
    var ok = form.classList.contains('rf-signup-interest') ? prepareInterestStep(form) : prepareEmailStep(form);
    if (!ok) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  // Bubble phase: if no captcha handler took over the submit, send it ourselves.
  document.addEventListener('submit', function (event) {
    var form = signupForm(event);
    if (!form || event.defaultPrevented) return;
    event.preventDefault();
    send(form);
  });
})();
